import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faFileAlt, faFilePdf, faTrash, faWindowClose } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import classNames from 'classnames';
import styles from './assets/render-file.module.scss';
const RenderFile = ({
    file,
    removeFile,
    number,
    download,
    typeViewFiles = 'normal',
}: {
    file: any;
    download?: boolean;
    removeFile?: (id: number | string) => void;
    number?: number;
    typeViewFiles?: 'normal' | 'forService';
}) => {
    const renderFIle = (file: any) => {
        const isImages: any = {
            image: <img src={file.attach} alt="some" />,
            another: <FontAwesomeIcon icon={faFileAlt} />,
            pdf: <FontAwesomeIcon icon={faFilePdf} />,
        };
        let type = '';
        switch (file.mimeType) {
            case 'image/jpeg':
                type = 'image';
                break;
            case 'image/png':
                type = 'image';
                break;
            case 'application/pdf':
                type = 'pdf';
                break;
            default:
                type = 'another';
        }

        return isImages[type];
    };
    const isMobile = window.innerWidth <= 800;
    const filename = file.path ? file.path : file.name;

    return (
        <>
            {typeViewFiles === 'normal' ? (
                <div className={classNames(styles.previewLi)}>
                    <div className={classNames(styles.previewWrap)}>
                        <div className={classNames(styles.previewFile)}>
                            {download && file.attach ? (
                                <a
                                    className={classNames(styles.linkDownload)}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    href={file.attach}
                                >
                                    {renderFIle(file)}
                                    <span className={classNames(styles.hover)}>
                                        {isMobile ? 'Download' : 'Click here to download the file'}
                                    </span>
                                </a>
                            ) : (
                                renderFIle(file)
                            )}
                            <span className={classNames(styles.previewFileTitle)}>
                                {file.path ? file.path : file.name}
                                {file.size ? [' - ' + file.size + ' bytes'] : ''}
                            </span>
                        </div>
                        {removeFile ? (
                            <button
                                className={classNames(styles.previewDeleteBtn)}
                                type={'button'}
                                onClick={() => {
                                    removeFile(file.id ? file.id : number);
                                }}
                            >
                                X
                            </button>
                        ) : null}
                    </div>
                </div>
            ) : (
                <div className={classNames(styles.previewLiS)}>
                    <div className={classNames(styles.previewWrapS)}>
                        <div className={classNames(styles.previewFile)}>
                            {download && file.attach ? (
                                <a
                                    className={classNames(styles.linkDownload)}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    href={file.attach}
                                >
                                    {renderFIle(file)}
                                </a>
                            ) : (
                                renderFIle(file)
                            )}
                        </div>
                        <div className={classNames(styles.previewFileContainer)}>
                            <a
                                className={classNames(styles.download)}
                                rel="noopener noreferrer"
                                target="_blank"
                                href={file.attach}
                            >
                                <FontAwesomeIcon icon={faDownload} /> Download
                            </a>
                        </div>
                        <div className={classNames(styles.previewFileContainer)}>
                            <span className={classNames(styles.previewFileTitleS)}>
                                {filename
                                    ? filename.length > 30
                                        ? `${filename.slice(0, 24)}...${filename.slice(filename.lastIndexOf('.'))}`
                                        : filename
                                    : ''}
                                {file.size ? [' - ' + file.size + ' bytes'] : ''}
                            </span>
                        </div>
                        {removeFile && (
                            <button
                                className={classNames(styles.previewDeleteBtn)}
                                type={'button'}
                                onClick={() => {
                                    removeFile(file.id ? file.id : number);
                                }}
                            >
                                X
                            </button>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default RenderFile;
